import css from './business-map.module.scss';
import { BusinessMapLocationItem, MapCategory } from './types';
import { ReactComponent as DiscountIcon } from 'src/assets/map/discount.svg';
import { ReactComponent as PhoneIcon } from 'src/assets/map/phone.svg';
import { ReactComponent as RequirementsIcon } from 'src/assets/map/requirements.svg';
import { ReactComponent as RouteIcon } from 'src/assets/map/infodiscont.svg';
import { ReactComponent as LinkArrow } from 'src/assets/services-arrow-btn-2.svg';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';

interface PointCardProps {
  data: BusinessMapLocationItem;
  category: MapCategory;
  filterByCompany: (name: string) => void;
  filter: boolean;
}

function PointCard({ data, category, filterByCompany, filter }: Readonly<PointCardProps>) {
  function copyToClipboard(text: string | undefined) {
    if (text) {
      navigator.clipboard.writeText(text);
      toast.success('Скопійовано в буфер обміну');
    }
  }
  return (
    <div className={css.pointCard}>
      {data.logo && (
        <div className={css.logoHeader}>
          <img src={data.logo} alt={data.logo} />
        </div>
      )}
      <div className={css.cardBody}>
        <div className={css.dataInfo}>
          <h3>
            {data?.title}
            <br />
          </h3>
          <span>{category.name}</span>
          <p>
            <DiscountIcon />
            {data?.discount}
          </p>
          <p>
            <RouteIcon />
            {data?.requirements}
          </p>
          {data?.url && (
            <p>
              <RequirementsIcon />
              <Link to={data.url} target='_blank' rel='noopener noreferrer'>
                Детальніше про пропозицію
              </Link>
            </p>
          )}
          {data?.phone && (
            <p className={css.phone} onClick={() => copyToClipboard(data?.phone)} aria-hidden>
              <PhoneIcon />
              {data?.phone}
            </p>
          )}
        </div>

        <button onClick={() => filterByCompany(filter ? data.title : '')}>
          {!filter && <LinkArrow className={css.arrowLeft} />}
          {filter ? 'Показати на мапі' : 'Повернутись'}
          {filter && <LinkArrow className={css.arrow} />}
        </button>
      </div>
    </div>
  );
}

export default PointCard;
